@if (!m_editing) {
  <span class="li-content ">{{getContent(item) | PipeTruncate:['18']}}</span>
}
@if (m_editing && editable) {
  <input inputrestriction="basic1" #editInput [(ngModel)]="m_value" class="li-content " value="{{getContent(item) | PipeTruncate:['20']}}"/>
}
@if (editable) {
  <span  class="editable">
    <span style="position: relative">
      @if (!this.m_editing) {
        <mat-icon class="pull-right" (click)="onEdit(true)" style="font-size: 1em; padding-top: 10px">edit</mat-icon>
      }
      @if (this.m_editing) {
        <mat-icon class="pull-right" (click)="onEdit(true)" style="font-size: 1em; padding-top: 10px; color: green">check</mat-icon>
      }
    </span>
  </span>
}
